import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, Mail, ArrowRight, AlertCircle } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { formatApiError } from '../lib/api';

export default function Login() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState('admin@odnoslab.com');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || 'Error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="grain min-h-screen bg-bg flex items-center justify-center px-5 py-10" data-testid="login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="mb-10 text-center">
          <div className="font-display text-5xl text-ink mb-2">MODARIA</div>
          <div className="text-eyebrow text-ink-muted">{`Panel · v1.0`}</div>
        </div>

        <form onSubmit={onSubmit} className="space-y-7 bg-bg-secondary border border-line rounded-md p-8 md:p-10" data-testid="login-form">
          <div>
            <label className="text-eyebrow mb-1 block flex items-center gap-2">
              <Mail size={12} /> Email
            </label>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-bare"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="text-eyebrow mb-1 block flex items-center gap-2">
              <Lock size={12} /> {`Contraseña / Password`}
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-bare"
              data-testid="login-password"
            />
          </div>
          {error && (
            <div className="text-danger text-xs font-mono uppercase tracking-[0.18em] flex items-center gap-2" data-testid="login-error">
              <AlertCircle size={14} /> {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="btn-acid w-full justify-center disabled:opacity-50"
            data-testid="login-submit"
          >
            {submitting ? 'Entrando…' : (<>Entrar <ArrowRight size={14} /></>)}
          </button>
        </form>

        <div className="text-center mt-6 space-y-2">
          <a href="/forgot-password" className="text-eyebrow text-ink-muted hover:text-ink block" data-testid="forgot-link">¿Olvidaste tu contraseña?</a>
          <a href="/" className="text-eyebrow text-ink-muted hover:text-ink block">← Volver al sitio</a>
        </div>
      </motion.div>
    </div>
  );
}
